// Linguistic Analysis Data for Sentence Structure Analysis
export const linguisticAnalysisExamples = [
  {
    id: 'example-1',
    title: 'Complex Sentence with Subordinate Clause',
    originalSentence: 'With my sporting background and experience, I believe that I have the interest, dedication and necessary experience for your trainee reporter vacancy',
    analysis: {
      mainPattern: 'S+V+O',
      basicStructure: 'Subject + Verb + Object',
      legendStructure: 'I(S) + believe(V) + that I have the interest, dedication and necessary experience for your trainee reporter vacancy(O)',
      detailedAnalysis: {
        subject: 'I',
        verb: 'believe',
        directObject: 'that I have the interest, dedication and necessary experience for your trainee reporter vacancy',
        indirectObject: null,
        complement: null,
        adverbial: 'With my sporting background and experience'
      },
      subordinateClauses: [
        {
          clause: 'that I have the interest, dedication and necessary experience for your trainee reporter vacancy',
          pattern: 'S+V+O',
          analysis: {
            subject: 'I',
            verb: 'have',
            directObject: 'the interest, dedication and necessary experience',
            indirectObject: null,
            complement: null,
            adverbial: 'for your trainee reporter vacancy'
          }
        }
      ],
      verbTense: 'present',
      specialFeatures: [
        'complex sentence with subordinate clause',
        'prepositional phrase as adverbial'
      ],
      rewriteOptions: {
        'S+V': 'I believe.',
        'S+V+O': 'I believe something.',
        'S+V+C': 'I am certain.',
        'S+V+IO+DO': 'I give someone something.',
        'S+V+O+C': 'I make something clear.'
      }
    }
  },
  {
    id: 'example-2',
    title: 'Simple Sentence with Adverbial',
    originalSentence: 'Students study hard every day for their exams',
    analysis: {
      mainPattern: 'S+V+A',
      basicStructure: 'Subject + Verb + Adverbial',
      legendStructure: 'Students(S) + study(V) + hard every day for their exams(A)',
      detailedAnalysis: {
        subject: 'Students',
        verb: 'study',
        directObject: null,
        indirectObject: null,
        complement: null,
        adverbial: 'hard every day for their exams'
      },
      subordinateClauses: [],
      verbTense: 'present',
      specialFeatures: [
        'simple sentence',
        'multiple adverbials'
      ],
      rewriteOptions: {
        'S+V': 'Students study.',
        'S+V+O': 'Students study books.',
        'S+V+C': 'Students are diligent.',
        'S+V+IO+DO': 'Students give teachers homework.',
        'S+V+O+C': 'Students make learning fun.'
      }
    }
  },
  {
    id: 'example-3',
    title: 'Compound Sentence with Coordinating Conjunction',
    originalSentence: 'I like reading books, but my brother prefers watching movies',
    analysis: {
      mainPattern: 'S+V+O + conjunction + S+V+O',
      basicStructure: 'Independent Clause + Coordinating Conjunction + Independent Clause',
      legendStructure: 'I(S) + like(V) + reading books(O) + but + my brother(S) + prefers(V) + watching movies(O)',
      detailedAnalysis: {
        subject: 'I (first clause), my brother (second clause)',
        verb: 'like, prefers',
        directObject: 'reading books, watching movies',
        indirectObject: null,
        complement: null,
        adverbial: null
      },
      subordinateClauses: [],
      verbTense: 'present',
      specialFeatures: [
        'compound sentence',
        'coordinating conjunction'
      ],
      rewriteOptions: {
        'S+V': 'I like.',
        'S+V+O': 'I like books.',
        'S+V+C': 'I am happy.',
        'S+V+IO+DO': 'I give him books.',
        'S+V+O+C': 'I make reading enjoyable.'
      }
    }
  },
  {
    id: 'example-4',
    title: 'Complex Sentence with Relative Clause',
    originalSentence: 'The book that you recommended is very interesting',
    analysis: {
      mainPattern: 'S+V+C',
      basicStructure: 'Subject + Verb + Complement',
      legendStructure: 'The book(S) + is(V) + very interesting(C)',
      detailedAnalysis: {
        subject: 'The book',
        verb: 'is',
        directObject: null,
        indirectObject: null,
        complement: 'very interesting',
        adverbial: null
      },
      subordinateClauses: [
        {
          clause: 'that you recommended',
          pattern: 'S+V+O',
          analysis: {
            subject: 'you',
            verb: 'recommended',
            directObject: 'that (relative pronoun referring to book)',
            indirectObject: null,
            complement: null,
            adverbial: null
          }
        }
      ],
      verbTense: 'present',
      specialFeatures: [
        'complex sentence with relative clause',
        'relative pronoun'
      ],
      rewriteOptions: {
        'S+V': 'The book is.',
        'S+V+O': 'The book contains stories.',
        'S+V+C': 'The book is interesting.',
        'S+V+IO+DO': 'The book gives readers knowledge.',
        'S+V+O+C': 'The book makes reading enjoyable.'
      }
    }
  },
  {
    id: 'example-5',
    title: 'Passive Voice Sentence',
    originalSentence: 'The letter was written by the student yesterday',
    analysis: {
      mainPattern: 'S+be+V(past participle)+by+A',
      basicStructure: 'Subject + be + Past Participle + by + Agent + Adverbial',
      legendStructure: 'The letter(S) + was written(V) + by the student + yesterday(A)',
      detailedAnalysis: {
        subject: 'The letter',
        verb: 'was written',
        directObject: null,
        indirectObject: null,
        complement: null,
        adverbial: 'by the student yesterday'
      },
      subordinateClauses: [],
      verbTense: 'past',
      specialFeatures: [
        'passive voice',
        'prepositional phrase as agent'
      ],
      rewriteOptions: {
        'S+V': 'The letter was.',
        'S+V+O': 'The letter contained information.',
        'S+V+C': 'The letter was important.',
        'S+V+IO+DO': 'The letter gave readers news.',
        'S+V+O+C': 'The letter made readers happy.'
      }
    }
  }
];

// Helper function to get analysis by ID
export const getAnalysisById = (id) => {
  return linguisticAnalysisExamples.find(example => example.id === id);
};

// Helper function to get all analysis examples
export const getAllAnalysisExamples = () => {
  return linguisticAnalysisExamples;
}; 